import No_Result_Found from "../../../../../assets/No_Result_Found.svg";
export const QuickFilterNotFound = () => {
  return (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "center",
        marginTop: "50%",
      }}
    >
      <img src={No_Result_Found} alt="no data found" />
      <h6 className="portlet__title ml-2 line-height-normal">
        Quick Filters not found!
      </h6>
      <p className="text_heading font-weight500 word-break ">
        You need to create quick filters in the filters tab.
      </p>
    </div>
  );
};
